// extracted by mini-css-extract-plugin
module.exports = {"slide":"TagManagment_slide_2pa9U","slide-reverse":"TagManagment_slide-reverse_2uL6W","alert":"TagManagment_alert_hAj5a","list":"TagManagment_list_2mu2b"};